import React from 'react'
import { TableCell } from '@mui/material';
import _ from 'lodash'
import { getNumberComma } from '../../utils/numberUtils';

const ProjectDeptCountCell = ({ headerRows, data }) => {
    if (!headerRows || !data) {
        return null;
    }

    return headerRows && headerRows.map((field, fIndex) => {
        let value = _.has(data, `${field.val}`) ? data[field.val] : '-';
        let formatValue = getNumberComma(value);

        return (
            <TableCell align="right" key={fIndex}>{formatValue} 건</TableCell>
        )
    })
}

export default ProjectDeptCountCell